import React from "react";

const Java_Date = () => {
  return (
    <div>
      <h1>Java Date</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Date in Java.</p>
    </div>
  );
};

export default Java_Date;
